var iphoneType = localStorage.getItem("iphoneType");

document.addEventListener("variant:change", (event) => {
  var variant = event.detail.variant;
  localStorage.setItem("iphoneType", variant.title);
});

var options = document.querySelectorAll(
  ".variant-picker__option .popover__value-list button"
);

setTimeout(function () {
  if (iphoneType != "" || iphoneType != null) {
    options.forEach((option) => {
      var title = option.querySelector("span").textContent;
      if (iphoneType == title) {
        option.click();
      }
    });
  }
}, 1000);


/* Code pour actualiser le texte de disponibilité lorsque l'on change de variante */

async function updateAvailability(section_id) {
  const url = new URL(window.location.href);
  const sectionId = section_id;

  try {
    const response = await fetch(`${url.pathname}?${url.searchParams.toString()}&section_id=${sectionId}`);
    const data = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const newAvailabilityText = doc.querySelector('.product-info_availability-text');

    if (newAvailabilityText) {
      document.querySelector('.product-info_availability-text').innerHTML = newAvailabilityText.innerHTML;
    }
  } catch (error) {
    console.error('Error fetching availability information:', error);
  }
}

document.addEventListener("variant:change", async () => {
  const section_id = document.querySelector('variant-picker').dataset.sectionId;
  await updateAvailability(section_id);
});


/* Ouvre le sélecteur de variante quand on clique sur "Choisissez votre modèle" sans iPhone sélectionné */
(function () {
  function initChooseModelHandler() {
    if (localStorage.getItem('iphoneType')) return;

    var productForm = document.querySelector('form[is="product-form"]');
    if (!productForm) return;

    var idInput = productForm.querySelector('input[name="id"]');
    if (!idInput || idInput.value) return;

    var submitBtn = productForm.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    submitBtn.removeAttribute('disabled');

    submitBtn.addEventListener('click', function (e) {
      if (localStorage.getItem('iphoneType')) return;

      e.preventDefault();
      e.stopPropagation();

      var variantSection = document.querySelector('.variant-picker__option');
      var trigger = document.querySelector(
        '.variant-picker__option button[aria-haspopup], .variant-picker__option .popover-trigger, .variant-picker__option summary'
      );

      if (variantSection) {
        variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      setTimeout(function () {
        if (trigger) trigger.click();
      }, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChooseModelHandler);
  } else {
    initChooseModelHandler();
  }
})();


/* Variation swatches : swap image + badges au hover, clic sans navigation */
(function () {
  function initVariationSwatches() {
    document.querySelectorAll('product-card').forEach(function (card) {
      var swatches = card.querySelectorAll('[data-var-img]');
      if (!swatches.length) return;

      var img = card.querySelector('.product-card__image--primary');
      if (!img) return;

      var figure = card.querySelector('.product-card__figure');

      function applyVariation(swatch) {
        img.srcset = '';
        img.src = swatch.dataset.varImg;

        var titleEl = card.querySelector('a.product-title');
        if (titleEl && swatch.dataset.varTitle) titleEl.textContent = swatch.dataset.varTitle;

        var varPrice = parseInt(swatch.dataset.varPrice, 10);
        if (varPrice) {
          var priceList = card.querySelector('price-list');
          var saleEl = priceList && priceList.querySelector('sale-price');
          var compareEl = priceList && priceList.querySelector('compare-at-price');
          if (saleEl) {
            saleEl.lastChild.replaceWith(
              document.createRange().createContextualFragment(formatSoldesPrice(Math.round(varPrice * 0.8)))
            );
          }
          if (compareEl) {
            compareEl.lastChild.replaceWith(
              document.createRange().createContextualFragment(formatSoldesPrice(varPrice))
            );
            compareEl.hidden = false;
          }
        }

        if (!figure) return;
        var template = swatch.querySelector('template.var-badges-tpl');
        var currentBadgeList = figure.querySelector('badge-list');
        var newBadgesHTML = '';

        if (template) {
          var tmp = document.createElement('div');
          tmp.appendChild(template.content.cloneNode(true));
          newBadgesHTML = tmp.innerHTML.trim();
        }

        if (currentBadgeList) {
          if (newBadgesHTML) {
            currentBadgeList.outerHTML = newBadgesHTML;
          } else {
            currentBadgeList.remove();
          }
        } else if (newBadgesHTML) {
          figure.insertAdjacentHTML('afterbegin', newBadgesHTML);
        }
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          applyVariation(swatch);
        });

        swatch.addEventListener('click', function (e) {
          e.preventDefault();

          applyVariation(swatch);

          var link = swatch.querySelector('a');
          var varUrl = link ? link.href : '';
          if (!varUrl) return;

          var mediaLink = card.querySelector('a.product-card__media');
          var titleLink = card.querySelector('a.product-title');
          if (mediaLink) mediaLink.href = varUrl;
          if (titleLink) titleLink.href = varUrl;

          card.querySelectorAll('[data-var-img] a.color-swatch').forEach(function (a) {
            a.classList.remove('is-selected');
          });
          if (link) link.classList.add('is-selected');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariationSwatches);
  } else {
    initVariationSwatches();
  }
})();


/* Utilitaire partagé : formatage monétaire pour les prix Soldes */
function formatSoldesPrice(cents) {
  var vars = window.themeVariables && window.themeVariables.settings;
  if (!vars) return '';
  var fmt = vars.currencyCodeEnabled ? vars.moneyWithCurrencyFormat : vars.moneyFormat;
  var amount = cents / 100;
  return fmt
    .replace('{{amount}}', amount.toFixed(2))
    .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
    .replace('{{amount_no_decimals}}', Math.round(amount).toString())
    .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString());
}

/* Soldes d'été 2026 : maintenir le prix -20% après chaque changement de variante */
(function () {
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail.variant;

    setTimeout(function () {
      var priceList = document.querySelector('.price-list--product');
      if (!priceList) return;

      var salePrice = priceList.querySelector('sale-price');
      var compareAtPrice = priceList.querySelector('compare-at-price');
      if (!salePrice) return;

      var discountedCents = Math.round(variant.price * 0.8);

      salePrice.lastChild.replaceWith(
        document.createRange().createContextualFragment(formatSoldesPrice(discountedCents))
      );
      salePrice.classList.add('text-on-sale');
      salePrice.classList.remove('text-subdued');

      if (compareAtPrice) {
        compareAtPrice.lastChild.replaceWith(
          document.createRange().createContextualFragment(formatSoldesPrice(variant.price))
        );
        compareAtPrice.hidden = false;
      }
    }, 0);
  });
})();


/* Clic sur image produit → ouvre la lightbox (mobile < 1000px) */
(function () {
  function initTapToZoom() {
    var gallery = document.querySelector('product-gallery[allow-zoom]');
    if (!gallery) return;

    var zoomBtn = gallery.querySelector('.product-gallery__zoom-button');
    if (!zoomBtn) return;

    gallery.querySelectorAll('.product-gallery__media').forEach(function (media) {
      media.addEventListener('click', function () {
        if (window.innerWidth >= 1000) return;
        zoomBtn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTapToZoom);
  } else {
    initTapToZoom();
  }
})();
